import { Text, TextLinkButton } from 'braid-design-system';

import { useLogin } from '#src/hooks/auth.tsx';

interface LoginLabelProps {
  redirect: string;
}

export const LoginLabel = ({ redirect }: LoginLabelProps) => {
  const { login } = useLogin();
  return (
    <Text tone="info">
      It appears you are not logged in.{` `}
      <TextLinkButton onClick={() => login({ returnTo: redirect })}>
        Log in
      </TextLinkButton>{' '}
      to pre-fill some details and enable SEEK to respond more quickly depending
      on the details provided.
    </Text>
  );
};
